import Alpine from 'alpinejs'

Alpine.data('copyToClipboard', () => ({

    copied: false,
    delayTimeout: null,

    async copy(value: string, delayResetCopiedMs=3000) {

        this.copied = false
        if(this.delayTimeout) {
            window.clearTimeout(this.delayTimeout)
        }
        
        const resetCopied = () => {
            this.copied = false
        }
        const initTimeout = () => {
            this.delayTimeout = window.setTimeout(resetCopied, delayResetCopiedMs)
        }
        
        if(navigator.clipboard) {
            
            return navigator.clipboard.writeText(value).then(() => {
                this.copied = true
                initTimeout()
                return true
            })
            
        } else {
            
            // avoid scrolling to bottom because its always in the view-port
            
            const textArea = document.createElement('textarea')
            textArea.value = value
            textArea.style.top = 0
            textArea.style.left = 0
            textArea.style.position = 'fixed'
            textArea.style.opacity = 0
            textArea.style.width = 1
            textArea.style.height = 1

            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()

            let copied;
            try {
                copied = document.execCommand('copy')
            } catch {
                copied = false
            }
            this.copied = copied
            if(copied) {
                initTimeout()
            }
            
            textArea.blur()            
            document.body.removeChild(textArea)
        }
    }

}))